import React from "react";

import { Template } from "chq";

import { Modal } from "@culturehq/components";
import ChqModal from "components/common/ChqModal";
import Card from "./Card";

interface ImageCardProps {
  onSelectedTemplate: (template: Template) => void;
  isSelectedTemplate?: boolean;
  template: Template;
}

const ImageCard: React.FC<ImageCardProps> = ({
  onSelectedTemplate, isSelectedTemplate, template
}) => (
  <ChqModal
    className="Template-Modal"
    entrance="zoomIn"
    trigger={(onTrigger: () => void) => (
      <Card
        onSelectedTemplate={onSelectedTemplate}
        onTrigger={onTrigger}
        isSelectedTemplate={isSelectedTemplate}
        template={template}
      />
    )}
  >
    <Modal.Body>
      <div className="Template-BgImage" style={{ backgroundImage: `url(${template.url})` }} />
      <img className="Template-Image" src={template.url} alt={template.description} />
    </Modal.Body>
  </ChqModal>
);

export default ImageCard;
